/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 16:59:05
 * @LastEditTime: 2022-06-06 15:09:32
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionList/Security/index.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { requireTwoFactor } from '@/src/request/settings/permission';
import { useRequest } from 'ahooks';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { getStoreUuid } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import css from '../style.module.less';

const Security = ({ requireTfa, onUpdate, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const storeUuid = getStoreUuid();

  const { run: _requireTwoFactor } = useRequest(
    (data) => requireTwoFactor(storeUuid, data),
    {
      manual: true,
      onSuccess: () => {
        onUpdate();
      },
    },
  );
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      rightPart={''}
      title={getI18n('usersAndPermissions.list.securityTitle')}>
      <Checkbox
        checked={requireTfa}
        onChange={_requireTwoFactor}
        disabled={disableEdit}>
        {getI18n('usersAndPermissions.list.securityCheckboxLabel')}
      </Checkbox>
      <span className={css.securityText}>
        {getI18n('usersAndPermissions.list.securityCheckboxExtra')}
      </span>
    </SectionWrapper>
  );
};

export default Security;
